import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { createSurchargeRelation, editSurchargeRelation } from 'RestAPIs/admin';

import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

const useSave = (isEdit: boolean, handleClose: () => void) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(
    isEdit ? editSurchargeRelation : createSurchargeRelation,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['surchargeRelations', 'list']
        });
        handleClose();
        showSuccessSnackbar();
      },
      onError: (error) => showError(error as AxiosError)
    }
  );

  return { mutate, isLoading };
};

export default useSave;
